import React from 'react';
import { render } from 'react-dom';
import { setConfig } from 'react-hot-loader';
import qs from 'qs';
import { isEmbeddedMode } from '@sunbit-dev/purchase-common/src/helpers/embeddedMode';
import { applicationSetup } from './utilities/applicationSetup/applicationSetup';

// Add types extensions
// TODO Change to import types in tsconfig
import '@sunbit-dev/purchase-common/src/extensions';
import App from '~/components/app/App';

(async () => {
  setConfig({
    reloadHooks: false,
  });

  const { pathname, origin, search } = window?.location || {};
  // Always start from a clean path and use the status to know the application point in flow
  if (pathname) history.replaceState({}, null, origin + search);

  const { referer } = qs.parse(search, { ignoreQueryPrefix: true }) as { referer?: string };
  if (isEmbeddedMode() && !!referer) {
    document.documentElement.setAttribute('data-embedded-in-iframe', 'true');
  }

  await applicationSetup();

  render(<App />, document.getElementById('root'));
})();
